export default {
  'meta': {
    'langName': 'HUNGARIAN',
    'lang': 'Magyar'
  },
  'title': 'TERMÉKVISSZAHÍVÁS KOSÁRPALÁNK B900 BOX NBA TARMAK',
  'description': '​Megállapítottuk, hogy fennáll a kockázata annak, hogy a BL 900-as kosárlabdapalánk eldől, ha azt a fogantyú nélkül használják.  \nA biztonságod érdekében azonnal hagyd abba a termék használatát a magasságállító fogantyú felszerelése nélkül!  \nA termék egy egyszerű eljárással és egy készlettel - amelyet ingyen elküldünk neked - biztonságossá tehető.  \nA termékvisszahívásnak szentelt weboldal jelenleg fejlesztés alatt áll. Segítségedre lesz a művelet végrehajtásához szükséges lépésekben.  \nTájékoztatunk, amint elérhetővé válik az oldal (július folyamán). ',
  'status': 'Translation validated by COUNTRY'
} as const
